<template>
  <div class="slide-factory">
    <component
      :is="slideComponent"
      :data="slideData.data"
      :slide-id="slideData.id"
    />
  </div>
</template>

<script>
export default {
  name: 'QuarterlySlideFactory',
  components: {
    'title-cover-slide': () => import('./slides/TitleCoverSlide.vue'),
    'section-divider-slide': () => import('./slides/SectionDividerSlide.vue'),
    'key-metric-slide': () => import('./slides/KeyMetricSlide.vue'),
    'stat-grid-slide': () => import('./slides/StatGridSlide.vue'),
    'chart-with-callouts-slide': () => import('./slides/ChartWithCalloutsSlide.vue'),
    'highlights-grid-slide': () => import('./slides/HighlightsGridSlide.vue'),
    'question-scores-slide': () => import('./slides/QuestionScoresSlide.vue'),
    'leaderboard-slide': () => import('./slides/LeaderboardSlide.vue'),
    'who5-breakdown-slide': () => import('./slides/WHO5BreakdownSlide.vue'),
    'recommendations-slide': () => import('./slides/RecommendationsSlide.vue'),
    'goal-distribution-slide': () => import('./slides/GoalDistributionSlide.vue'),
    'focus-alignment-slide': () => import('./slides/FocusAlignmentSlide.vue'),
    'closing-slide': () => import('./slides/ClosingSlide.vue'),
    'empty-slide': () => import('./slides/EmptySlide.vue')
  },
  props: {
    slideData: {
      type: Object,
      required: true,
      default: () => ({ id: 'empty', type: 'Empty', data: {} })
    }
  },
  computed: {
    slideComponent() {
      const typeMap = {
        'TitleCover': 'title-cover-slide',
        'SectionDivider': 'section-divider-slide',
        'KeyMetric': 'key-metric-slide',
        'StatGrid': 'stat-grid-slide',
        'ChartWithCallouts': 'chart-with-callouts-slide',
        'HighlightsGrid': 'highlights-grid-slide',
        'QuestionScores': 'question-scores-slide',
        'Leaderboard': 'leaderboard-slide',
        'WHO5Breakdown': 'who5-breakdown-slide',
        'Recommendations': 'recommendations-slide',
        'GoalDistribution': 'goal-distribution-slide',
        'FocusAlignment': 'focus-alignment-slide',
        'Closing': 'closing-slide',
        'Empty': 'empty-slide'
      };
      return typeMap[this.slideData.type] || 'empty-slide';
    }
  }
};
</script>

<style lang="scss" scoped>
.slide-factory {
  width: 100%;
  height: 100%;
}
</style>
